<template>
  <div class="notification-card">
    <p class="notification-message-text">{{ notificationDetails.notificationMessage }}</p>
    <p class="notification-time-text">Notification received on {{ formattedNotificationTime }}</p>
  </div>
</template>

<script>
  export default {
    name: "Notification.vue",
    props: {
      notificationDetails: Object
    },
    data() {
      return {
        formattedNotificationTime: null
      }
    },
    mounted() {
      // convert the format of the comment date
      const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
        "Jul", "Aug", "Sept", "Oct", "Nov", "Dec"
      ];

      const taskDueDate = new Date(this.notificationDetails.notificationCreationTime)
      const year = taskDueDate.getFullYear()
      const month = monthNames[taskDueDate.getMonth()]
      const day = taskDueDate.getDate()
      const hours = taskDueDate.getHours()
      const minutes = taskDueDate.getMinutes() < 10 ? '0' + taskDueDate.getMinutes() : taskDueDate.getMinutes()

      this.formattedNotificationTime = month + ' ' + day + ', ' + year + ' at ' + hours + ':' + minutes
    }
  }
</script>

<style scoped>
  .notification-card {
    padding: 1em;
    margin-bottom: 0.75em;
    border: 1px solid #212441;
  }

  .notification-message-text {
    margin-bottom: 0.5em;
  }

  .notification-time-text {
    font-size: 0.9em;
    margin-bottom: 0;
    font-style: italic;
  }
</style>
